module.exports = __webpack_public_path__ + "static/media/LogoManyFlowsVertical.df790bcf.svg";